document.addEventListener('DOMContentLoaded', function () {
  var form = document.querySelector('[data-hb-starter-kit-form]');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var button = form.querySelector('.hb-starter-kit__add-btn');
    var label = button.querySelector('.hb-starter-kit__add-label');
    var defaultLabel = label.getAttribute('data-default-label');

    if (button.disabled) return;

    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: form.querySelector('[name="id"]').value,
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error(err.description || 'Add to cart failed');
          });
        }
        return response.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        label.textContent = ((window.hbStrings || {}).addedCheck || 'Lisätty ✓');

        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(function () {
          button.classList.remove('is-added');
          label.textContent = defaultLabel;
        }, 2000);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        label.textContent = ((window.hbStrings || {}).error || 'Virhe — yritä uudelleen');

        setTimeout(function () {
          label.textContent = defaultLabel;
        }, 2000);
      });
  });
});
